import { useCallback } from 'react';

import { useMytaverse } from '@providers/MytaverseProvider';
import { GenderType } from '@features/avaturn/interfaces';
import { useUserProfileHelperType } from '@features/avaturn/pages/Avaturn/interfaces';

const getAvaturnBrand = (): string => {
  return 'no-brand';
};

const useUserProfileHelper: useUserProfileHelperType = () => {
  const { user } = useMytaverse();

  const getProcessedBrand = useCallback(() => getAvaturnBrand(), []);

  const getGender = useCallback(() => {
    if (!user?.gender) {
      return GenderType.MALE;
    }
    return user?.gender?.toLowerCase() === GenderType.FEMALE
      ? GenderType.FEMALE
      : GenderType.MALE;
  }, [user?.gender]);

  return {
    getProcessedBrand,
    getGender,
  };
};

export default useUserProfileHelper;
